import Swal from "sweetalert2";

export const toastAlert = (text) => {
	Swal.fire({
		customClass: "alert-custom",
		text: text,
		confirmButtonText: "확인",
	});
};
